import styles from "./styles.module.scss";

const EntryBlock = () => {
  return (
    <section className={styles.Container}>
      <div className="container">
        <div className={styles.EntryBlock}>

          <div className={styles.EntryBlock_info}>
            <h1>Сувениры для <span>доноров</span></h1>
            <p className={styles.EntryBlock_info__thin}>
              Сдавайте кровь и её компоненты — получайте уникальные подарки. Доноры с подтверждёнными донациями могут получить значок и браслет. Отправка браслетов начнётся в июне 2025 года.
              <br /><br />
              Мы <span className={styles.EntryBlock_info__bold}>отправляем сувениры один раз в год</span>, чтобы бережно использовать ресурсы. Если один сувенир уже доступен, а другой скоро будет, подождите и подайте заявку на оба сразу, чтобы получить их вместе. Повторная отправка в течение года не предусмотрена.
            </p>
          </div>

          <img src="/static/images/souvenir/entry.png" alt="значки" />

        </div>
      </div>
    </section>
  );
};

export default EntryBlock;
